<script type="text/jsx" lang="jsx">
import { createEditDeltaComponent } from '@/components/edit-delta-factory';
import commonMixin from '@/plans/EVENT_SAAS/mixin';
import { planTypes } from '@/common/constants';

export default createEditDeltaComponent({
  name: 'EventSaasEditDelta',
  planType: planTypes.EVENT_SAAS,
  mixin: commonMixin,
  withReplenish: true,
  className: 'opc-ze-edit-delta',
  hideConfigDescription: true,
});
</script>

<style lang="scss">
.opc-ze-edit-delta {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
